import React from 'react'
import styles from './RangeInput.scss'
import InputRange from 'react-input-range'

export class RangeInput extends React.PureComponent {
  render () {
    const {style, ...props} = this.props
    return (
      <div className={styles.RangeInput} style={style}>
        <InputRange {...props} />
      </div>
    )
  }
}
